<button class="button" [class.button_reverse]="reverse" (click)="onClick()">
  <mat-icon class="icon">{{ icon }}</mat-icon>
  <span class="text" [style.font-weight]="fontWeight ?? 'normal'">{{ text }}</span>
</button>
